export const toValidArray = (value) => {
  const arr = Array.isArray(value) ? value : [value];
  return arr.filter((e) => e !== null && e !== undefined);
};
